import { render, staticRenderFns } from "./CompanyDepartment.vue?vue&type=template&id=06b043d0"
import script from "./CompanyDepartment.vue?vue&type=script&lang=js"
export * from "./CompanyDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports